import FormattedMessage from 'I18n/components/FormattedMessage';
import styled, { css } from 'styled-components';
import SVGKnowledgeBase from 'visitor-ui-component-library-icons/icons/SVGKnowledgeBase';
import SVGWebsite from 'visitor-ui-component-library-icons/icons/SVGWebsite';
import { NEUTRAL_400, NEUTRAL_500, NEUTRAL_900, NEUTRAL_1600 } from 'visitor-ui-component-library/constants/WidgetColors';
import { useTheme } from '../theming/contexts/ThemeContext';
import { useWidgetModalOrContext } from '../widget-modal/WidgetModalContext';
import { SourcesModalContent } from './SourcesModalContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ICON_SIZE = 16;
const ICON_OVERLAP = 4;
const IconWrapper = styled.div.withConfig({
  displayName: "SourcesLine__IconWrapper"
})(["position:relative;width:", "px;margin-right:4px;"], ({
  $sourcesLength
}) => ICON_SIZE + (ICON_SIZE - ICON_OVERLAP) * ($sourcesLength - 1));
const iconBaseStyles = css(["background-color:", ";color:", ";fill:", ";border:1px solid ", ";border-radius:8px;padding:3px;width:16px;height:16px;&:not(:first-child){position:absolute;left:", "px;}"], NEUTRAL_400, NEUTRAL_1600, NEUTRAL_1600, NEUTRAL_500, ({
  $index
}) => $index * 12);
const StyledKBIcon = styled(SVGKnowledgeBase).withConfig({
  displayName: "SourcesLine__StyledKBIcon"
})(["", ""], iconBaseStyles);
const StyledWebsiteIcon = styled(SVGWebsite).withConfig({
  displayName: "SourcesLine__StyledWebsiteIcon"
})(["", ""], iconBaseStyles);
const StyledButton = styled.button.withConfig({
  displayName: "SourcesLine__StyledButton"
})(["position:relative;display:flex;align-items:center;justify-content:flex-start;width:fit-content;height:30px;border:none;padding:0;background-color:transparent;cursor:pointer;font-size:12px;line-height:14px;font-weight:300;color:", ";text-align:left;"], NEUTRAL_900);
const SourcesButtonAsLink = ({
  accentColor,
  children,
  navigateToKnowledgeBaseArticle,
  sources
}) => {
  const {
    openModal
  } = useWidgetModalOrContext();
  const handleClick = () => {
    openModal(SourcesModalContent({
      accentColor,
      navigateToKnowledgeBaseArticle,
      sources
    }));
  };
  return /*#__PURE__*/_jsx(StyledButton, {
    type: "button",
    onClick: handleClick,
    children: children
  });
};
SourcesButtonAsLink.displayName = 'SourcesButtonAsLink';
export default function SourcesLine({
  sources,
  navigateToKnowledgeBaseArticle
}) {
  const theme = useTheme();
  const {
    widgetAccent
  } = theme;
  return /*#__PURE__*/_jsxs(SourcesButtonAsLink, {
    accentColor: widgetAccent,
    navigateToKnowledgeBaseArticle: navigateToKnowledgeBaseArticle,
    sources: sources,
    children: [/*#__PURE__*/_jsx(IconWrapper, {
      $sourcesLength: sources.length,
      children: sources.map((source, index) => {
        if (source.hubSpotContentType === 'KB_ARTICLE') {
          return /*#__PURE__*/_jsx(StyledKBIcon, {
            $index: index
          }, source.citationId);
        } else {
          return /*#__PURE__*/_jsx(StyledWebsiteIcon, {
            $index: index
          }, source.citationId);
        }
      })
    }), sources.length === 1 ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-visitor-message-history.source.one",
      options: {
        count: 1
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-visitor-message-history.source.other",
      options: {
        count: sources.length
      }
    })]
  });
}
SourcesLine.displayName = 'SourcesLine';